Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionLink = void 0;
var ActionLink_1 = require("./ActionLink");
Object.defineProperty(exports, "ActionLink", { enumerable: true, get: function () { return ActionLink_1.ActionLink; } });
exports.default = ActionLink_1.ActionLink;
//# sourceMappingURL=index.js.map